"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostedClientLoadedEvent = void 0;
class HostedClientLoadedEvent extends Event {
    constructor(init) {
        super(HostedClientLoadedEvent.TYPE);
        this.init = init;
    }
}
exports.HostedClientLoadedEvent = HostedClientLoadedEvent;
HostedClientLoadedEvent.TYPE = "hosted-client-loaded";
//# sourceMappingURL=hosted-client-loaded-event.js.map